// @flow
export function formatSeconds(secs: string | number): string {
    let sec_num = parseInt(secs, 10),
        hours   = Math.floor(sec_num / 3600),
        minutes = Math.floor((sec_num - (hours * 3600)) / 60);

  return `${hours}h${hours > 1 ? 's' : ''} ${minutes}min${minutes > 1 ? 's' : ''}`;
}
